import moment from 'moment'
moment.locale('zh-cn')

function formatDate(value: any, arg: string | undefined) {
    if (value) {
        if (arg) {
            if (arg === 'fromNow') { return moment(String(value)).fromNow() }
            return moment(String(value)).format(arg)
        }
        return moment(String(value)).format('YYYY-MM-DD HH:mm')
    }
}

function formatYearMonthDayDate(value: any, arg: string | undefined) {
    if (value) {
        if (arg) {
            if (arg === 'fromNow') { return moment(String(value)).fromNow() }
            return moment(String(value)).format(arg)
        }
        return moment(String(value)).format('YYYY-MM-DD')
    }
}

function currency(value: any) {
    // if (value) {
    //     return '￥' + parseFloat(value).toFixed(2)
    // }
    // return value
    return `${number_format(value  as number,2,'.','\'')}`
}

/**
 * 格式化数字
 * @param  {[string | number]} number  [要格式化的数字]
 * @param  {[number]} decimals         [保留几位小数]
 * @param  {[string]} dec_point        [小数点符号]
 * @param  {[string]} thousands_sep    [千分位符号]
 * @param  {[string]} roundtag         [舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入]
 * @return {[string]} 格式化后的结果
 */
function number_format(number: string | number, decimals:number, dec_point:string, thousands_sep:string, roundtag:string = 'ceil') {
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    roundtag = roundtag || "ceil"; //"ceil","floor","round"
    let n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = [''],
        toFixedFix = function (n:number, prec:number) {

            let k = Math.pow(10, prec);
            console.log();

            return '' + parseFloat(((Math as any)[roundtag])(parseFloat((n * k).toFixed(prec*2))).toFixed(prec*2)) / k;
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

function formatMobilePhone(value:any){
  if(!value || typeof value !=='string'){
    return value;
  }
  if(/^(\d{4,20})$/.test(value)){
    const result = [];
    for (let i = 0;i<value.length;i++){
      if((i+1)%4 === 0){
        result.push(' ')
      }
      result.push(value[i])
    }
    return result.join('');
  } else {
    return value;
  }
}




export default {
    formatDate,
    formatYearMonthDayDate,
    currency,
    number_format,
    formatMobilePhone
}
